import React, { useState, useEffect } from 'react';
import NavLinks from '../Navbar/NavLinks';
import img from '../../assets/images/tnrf-logo-white-bg-removed.png';
import { ADDRESS, FACEBOOK_URL } from '../../constants/contact';

const NavBar = () => {
  const [top, setTop] = useState(!window.scrollY);
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  useEffect(() => {
    const scrollHandler = () => {
      window.pageYOffset > 10 ? setTop(false) : setTop(true);
    };
    window.addEventListener('scroll', scrollHandler);
    return () => window.removeEventListener('scroll', scrollHandler);
  }, [top]);

  return (
    <>
      <nav
        className={`fixed top-0 w-full z-50 transition duration-300 ease-in-out hero-navbar ${
          !top ? 'hero-navbar-scrolled' : 'hero-navbar-top'
        }`}
      >
        {/* Top Header Section */}
        <div className="hero-navbar-header">
          <div className="container mx-auto px-4 sm:px-6 md:px-8">
            <div className="relative">

              {/* Logo + Nav Links — absolutely centered over full container width.
                  5-column equal grid ensures "Upcoming Events" (col 3) is at exactly 50%. */}
              <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
                <img
                  src={img}
                  alt="TRNF Logo"
                  className="h-20 w-20 sm:h-24 sm:w-24 md:h-28 md:w-28 lg:h-32 lg:w-32 xl:h-36 xl:w-36 cursor-pointer hover:scale-105 transition-transform duration-200 pointer-events-auto"
                  onClick={scrollToTop}
                />
                <NavLinks className="hidden lg:grid lg:grid-cols-5 w-full mt-8 pb-3 justify-items-center pointer-events-auto" />
              </div>

              {/* Flow row — sets the container height; left/right elements sit in normal flow */}
              <div className="flex items-center min-h-[96px] sm:min-h-[112px] lg:min-h-[220px]">

                {/* Desktop Address Info - Left side */}
                <div className="hidden lg:block text-left relative z-10">
                  <div className="text-white/90 text-lg font-medium drop-shadow-md">
                    <div className="flex items-center space-x-2 mb-1">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                      </svg>
                      <span>{ADDRESS}</span>
                    </div>
                    <div className="text-md text-white/60 pl-7">
                      Harford County, Maryland
                    </div>
                  </div>
                </div>

                {/* Mobile: Hamburger | Desktop: Facebook link — pushed to far right */}
                <div className="flex items-center ml-auto relative z-10">
                  <div className="lg:hidden">
                    <button
                      className="p-3 rounded-lg text-white hover:bg-white/10 transition-colors min-w-[44px] min-h-[44px] flex items-center justify-center"
                      onClick={handleClick}
                      aria-label={isOpen ? 'Close Menu' : 'Open Menu'}
                    >
                      <svg
                        className="h-6 w-6 fill-current"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                      >
                        {isOpen ? (
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M18.278 16.864a1 1 0 0 1-1.414 1.414l-4.829-4.828-4.828 4.828a1 1 0 0 1-1.414-1.414l4.828-4.829-4.828-4.828a1 1 0 0 1 1.414-1.414l4.829 4.828 4.828-4.828a1 1 0 1 1 1.414 1.414l-4.828 4.829 4.828 4.828z"
                          />
                        ) : (
                          <path
                            fillRule="evenodd"
                            d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z"
                          />
                        )}
                      </svg>
                    </button>
                  </div>

                  {/* Desktop: Facebook icon */}
                  <div className="hidden lg:flex items-center space-x-4">
                    <a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer"
                       aria-label="Follow us on Facebook"
                       className="text-white/70 hover:text-blue-400 transition-colors p-2 rounded-lg hover:bg-white/10">
                      <svg className="w-6 h-6 fill-current" viewBox="0 0 24 24">
                        <path d="M13.397 20.997v-8.196h2.765l.411-3.209h-3.176V7.548c0-.926.258-1.56 1.587-1.56h1.684V3.127A22.336 22.336 0 0 0 14.201 3c-2.444 0-4.122 1.492-4.122 4.231v2.355H7.332v3.209h2.753v8.202h3.312z"/>
                      </svg>
                    </a>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

      </nav>

      {/* Mobile Overlay — outside <nav> so z-index is in the root stacking context */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black opacity-50 z-40 lg:hidden"
          onClick={handleClick}
        ></div>
      )}

      {/* Mobile Sidebar — outside <nav>, z-index above overlay and nav */}
      <div className={`mobile-sidebar fixed top-0 right-0 h-full w-80 max-w-[85vw] transform transition-transform duration-300 ease-in-out z-50 overflow-y-auto lg:hidden ${isOpen ? 'translate-x-0' : 'translate-x-full'}`}>
          {/* Mobile sidebar header */}
          <div className="flex items-center justify-between p-6 border-b border-white/20">
            <div className="flex items-center space-x-3">
              <img src={img} alt="TRNF Logo" className="h-12 w-12" />
              <div>
                <h2 className="text-xl font-bold text-white drop-shadow-lg">Menu</h2>
              </div>
            </div>
            <button
              onClick={closeMenu}
              className="text-white/80 hover:text-white transition-colors p-2 hover:bg-white/10 rounded-full min-w-[44px] min-h-[44px] flex items-center justify-center"
              aria-label="Close Menu"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          {/* Mobile menu content */}
          <div className="flex flex-col p-6 mt-4 pb-8 min-h-0">
            <NavLinks className="flex flex-col space-y-6" onLinkClick={closeMenu} />

            <div className="mt-8 pt-6 border-t border-white/20">
              <div className="text-center space-y-4">
                <div className="pt-4">
                  <a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer"
                     className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-4 px-6 rounded-lg text-lg transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl flex items-center justify-center space-x-3">
                    <svg className="w-6 h-6 fill-current" viewBox="0 0 24 24">
                      <path d="M13.397 20.997v-8.196h2.765l.411-3.209h-3.176V7.548c0-.926.258-1.56 1.587-1.56h1.684V3.127A22.336 22.336 0 0 0 14.201 3c-2.444 0-4.122 1.492-4.122 4.231v2.355H7.332v3.209h2.753v8.202h3.312z"/>
                    </svg>
                    <span>Follow Us on Facebook</span>
                  </a>
                </div>

                {/* Mobile Address Info */}
                <div className="pt-6 border-t border-white/20 mt-6">
                  <div className="text-center text-white">
                    <h4 className="text-xl font-semibold mb-3 text-white/90">Visit Us</h4>
                    <div className="space-y-2">
                      <div className="flex items-center justify-center space-x-2">
                        <svg className="w-5 h-5 text-white/80" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                        <span className="text-lg font-medium">{ADDRESS}</span>
                      </div>
                      <div className="text-md text-white/60 text-center">
                        Harford County, Maryland
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </>
  );
};

export default NavBar;
